// src/components/wizard/WizardChallenge.jsx
import React from 'react';
import styles from './WizardStep.module.css';

const OPTIONS = [
  { value:'mental',     icon:'🧠', label:'Mental health',        desc:'PTSD, anxiety, depression, OSI, moral injury' },
  { value:'financial',  icon:'💰', label:'Financial support',    desc:'Benefits, emergency funds, compensation' },
  { value:'housing',    icon:'🏠', label:'Housing',              desc:'Finding stable or transitional housing' },
  { value:'employment', icon:'💼', label:'Employment',           desc:'Civilian careers, trades, entrepreneurship' },
  { value:'family',     icon:'❤️', label:'Family & relationships',desc:'Counselling, childcare, deployment support' },
  { value:'medical',    icon:'🏥', label:'Medical & rehab',      desc:'Physical injury, rehabilitation, chronic pain' },
];

export default function WizardChallenge({ selected, onToggle, canContinue, onBack, onNext, onSkip }) {
  return (
    <div className={styles.stepWrap}>
      <p className={styles.eyebrow}>What you're navigating</p>
      <h1 className={styles.title}>What's the main area<br />you need <em>help with?</em></h1>
      <p className={styles.subSm}>Pick the areas most relevant to you.</p>
      <p className={styles.multiHint}>Select all that apply</p>

      <div className={`${styles.optGrid} ${styles.optGrid3}`} style={{ maxWidth: 660 }}>
        {OPTIONS.map(o => (
          <button
            key={o.value}
            className={`${styles.optCard} ${selected.includes(o.value) ? styles.selected : ''}`}
            onClick={() => onToggle(o.value)}
          >
            <div className={styles.optIcon}>{o.icon}</div>
            <div>
              <div className={styles.optLabel}>{o.label}</div>
              <div className={styles.optDesc}>{o.desc}</div>
            </div>
          </button>
        ))}
      </div>

      <div className={styles.btnRow}>
        <button className={styles.btnBack} onClick={onBack}>← Back</button>
        <button className={styles.btnNext} onClick={onNext} disabled={!canContinue}>Continue →</button>
        <button className={styles.btnText} onClick={onSkip}>Skip all</button>
      </div>
    </div>
  );
}
